/**
 * Employee Web — `/me/tasks` list route.
 *
 * The caller's own tasks (standalone + lifecycle rows assigned to them),
 * with status / overdue / search filters. UI lives in
 * `@linkhr/employee-self-service` (`MyTasksSection`); the route stays thin.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "@linkhr/i18n";
import { PageHeader } from "@linkhr/design-system";
import { MyTasksSection } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/tasks/")({
  component: MeTasksIndexRoute,
});

function MeTasksIndexRoute(): JSX.Element {
  const { t } = useTranslation("tasks");
  return (
    <section className="flex flex-col gap-lg">
      <PageHeader title={t("tasks:nav.myTasks")} />
      <MyTasksSection />
    </section>
  );
}
